import { motion } from "framer-motion";
import { Flame, Leaf, Sparkles } from "lucide-react";
import { IMAGES } from "./data";

const VALUES = [
  { icon: Flame, title: "Clay Tandoor Fire", text: "Kebabs and naan cooked over real charcoal heat, the traditional way." },
  { icon: Sparkles, title: "Fresh-Ground Spices", text: "Aromatic masalas roasted and ground in-house for depth of flavour." },
  { icon: Leaf, title: "Quality Ingredients", text: "Fresh local produce, slow cooking and plenty of passion in every pot." },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative scroll-mt-20 overflow-hidden py-20 sm:py-28">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, x: -32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="relative overflow-hidden rounded-2xl border border-[#C97B5F]/20 shadow-[0_30px_80px_rgba(0,0,0,0.6)]">
            <img src={IMAGES.tandoor} alt="Curry Story Indian Restaurant storefront in Chapel Hill" className="aspect-[4/3] w-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#FDFCF9]/70 via-transparent to-transparent" />
          </div>
          <div className="glass-panel absolute -bottom-6 -right-2 rounded-xl border border-[#C97B5F]/25 px-5 py-4 shadow-xl sm:-right-6">
            <p className="font-display text-3xl font-bold text-gold-gradient">100%</p>
            <p className="mt-0.5 text-[10px] font-bold uppercase tracking-[0.2em] text-stone-600">Authentic Recipes</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#E86A24]">About Curry Story</p>
          <h2 className="mt-3 font-display text-2xl font-semibold tracking-tight text-[#3A2C1E] sm:text-3xl lg:text-4xl">
            The True Story of<br />Indian Flavours
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-stone-600 sm:text-base">
            At Curry Story Indian Restaurant, we bring the rich flavours and traditions of India to Chapel Hill. Our menu is inspired by authentic Indian recipes, freshly prepared with quality ingredients, aromatic spices, and plenty of passion.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-stone-600 sm:text-base">
            Whether you're craving a comforting curry, delicious tandoor dishes, or classic Indian favourites, we aim to make every meal a memorable experience.
          </p>

          <div className="mt-10 border-t border-[#C97B5F]/15">
            {VALUES.map((v, i) => (
              <div
                key={v.title}
                data-testid={`about-value-${v.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group flex items-start gap-5 border-b border-[#C97B5F]/15 py-5 sm:gap-8 sm:py-6"
              >
                <span className="font-display text-2xl font-bold text-[#8A3324]/35 transition-colors duration-300 group-hover:text-[#E86A24] sm:text-3xl">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="text-sm font-bold uppercase tracking-[0.15em] text-[#3A2C1E] transition-colors duration-300 group-hover:text-[#8A3324]">{v.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-stone-500">{v.text}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
